import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/bulk-assign-users`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const bulkAssignUsers = {
  post: apiPathFunc(pathBase),
};
